const notificationTypeMapping = new Map([
  ['customer_status_change', 'Cancellations'],
  ['change_order_status_change', 'Change Order'],
  ['credit_check_status_change', 'Credit Check'],
  ['customer_hold_status_change', 'Customer Hold'],
  ['step_doc_status_change', 'Funding Milestones'],
  ['step_status_change', 'Step'],
  ['stip_required_change', 'Stipulation Requirement'],
  ['stip_status_change', 'Stipulation Status'],
  ['title_status_change', 'Title'],
]);

export const notificationRoleMapping = new Map([
  ['adhoc_subscriber', 'Additional Subscriber'],
  ['admin', 'Admin'],
  ['branch_manager', 'Branch Manager'],
  ['ops_manager', 'Ops Manager'],
]);

export default notificationTypeMapping;
